// Copyright (C) 2021 Bystronic Laser AG

export enum PlanState {
  Inactive = 0,
  Started = 1,
  Completed = 2,
  PartiallyCompleted = 3,
  Failed = 4,
}
